<section class="public-trip-calculator" [ngClass]="{'public-trip-calculator--compact': compact}">
    <div class="public-trip-calculator__header">
        <div>
            <div class="public-trip-calculator__eyebrow">Интерактивный расчет</div>
            <h2>{{ contextTitle() }}</h2>
            <p>{{ contextLead() }}</p>
        </div>

        <div class="public-trip-calculator__source"
             [ngClass]="'public-trip-calculator__source--' + fuelPriceSourceTone()">
            <span>{{ loading ? 'Обновляем данные' : fuelPriceSourceLabel() }}</span>
            <strong *ngIf="!loading">{{ recordsCountLabel() }}</strong>
        </div>
    </div>

    <div class="public-trip-calculator__body">
        <div class="public-trip-calculator__form">
            <label class="public-trip-calculator__field">
                <span>Класс автомобиля</span>
                <select
                    name="vehicle_class"
                    [ngModel]="vehicleClass"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onVehicleClassChange($event)"
                >
                    <option *ngFor="let option of vehicleClassOptions" [value]="option.id">
                        {{ option.label }}
                    </option>
                </select>
                <small>{{ vehicleClassOptions[vehicleClass === 'crossover' ? 1 : 0].description }}</small>
            </label>

            <label class="public-trip-calculator__field">
                <span>Топливо</span>
                <select
                    name="fuel_type"
                    [ngModel]="fuelType"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onFuelTypeChange($event)"
                >
                    <option *ngFor="let option of fuelTypeOptions" [value]="option.id">
                        {{ option.label }}
                    </option>
                </select>
                <small>Цена литра подтягивается автоматически.</small>
            </label>

            <label class="public-trip-calculator__field">
                <span>Цена литра</span>
                <div class="public-trip-calculator__input-postfix">
                    <input
                        type="number"
                        inputmode="decimal"
                        min="1"
                        step="0.01"
                        name="fuel_price"
                        [ngModel]="fuelPrice"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onFuelPriceChange($event)"
                        (focus)="onFuelPriceFocus($event)"
                    >
                    <span>₽/л</span>
                </div>
                <small>{{ fuelPriceSourceLabel() }}</small>
            </label>

            <label class="public-trip-calculator__field">
                <span>Средний расход</span>
                <div class="public-trip-calculator__input-postfix">
                    <input
                        type="number"
                        inputmode="decimal"
                        min="1"
                        step="0.1"
                        name="consumption"
                        [ngModel]="consumption"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onConsumptionChange($event)"
                        (focus)="onConsumptionFocus($event)"
                    >
                    <span>л/100 км</span>
                </div>
                <small>Можно поправить под свою машину.</small>
            </label>

            <section class="public-trip-calculator__distance-source" aria-label="Расстояние поездки">
                <div class="public-trip-calculator__mode-switch" role="group"
                     aria-label="Способ задания расстояния поездки">
                    <button
                        type="button"
                        [attr.aria-pressed]="distanceMode === 'manual'"
                        [class.public-trip-calculator__mode-button--active]="distanceMode === 'manual'"
                        (click)="onDistanceModeChange('manual')"
                    >
                        Ввести километраж
                    </button>
                    <button
                        type="button"
                        [attr.aria-pressed]="distanceMode === 'route'"
                        [class.public-trip-calculator__mode-button--active]="distanceMode === 'route'"
                        (click)="onDistanceModeChange('route')"
                    >
                        Указать города
                    </button>
                </div>

                <div class="public-trip-calculator__manual-distance" [hidden]="distanceMode !== 'manual'">
                    <label class="public-trip-calculator__field public-trip-calculator__field--distance">
                        <span>Километраж в одну сторону</span>
                        <div class="public-trip-calculator__input-postfix">
                            <input
                                type="number"
                                inputmode="decimal"
                                min="1"
                                step="1"
                                name="distance"
                                [ngModel]="distance"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onDistanceChange($event)"
                                (focus)="onDistanceFocus($event)"
                            >
                            <span>км</span>
                        </div>
                        <small>Введите расстояние только в одну сторону.</small>
                    </label>

                    <label class="public-trip-calculator__toggle">
                        <input
                            type="checkbox"
                            name="round_trip"
                            [ngModel]="roundTrip"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onRoundTripChange($event)"
                        >
                        <span>Учитывать дорогу обратно</span>
                    </label>
                </div>

                <div
                    class="public-trip-calculator__route-distance"
                    *ngIf="routeModeInitialized"
                    [hidden]="distanceMode !== 'route'"
                >
                    <app-route-planner
                        [compact]="true"
                        [context]="context === 'fuel' ? 'fuel' : 'trip'"
                        [roundTrip]="roundTrip"
                        (routeCalculated)="onRouteCalculated($event)"
                        (routeInvalidated)="onRouteInvalidated()"
                        (roundTripChange)="onRoundTripChange($event)"
                    ></app-route-planner>
                </div>
            </section>
        </div>

        <aside class="public-trip-calculator__result"
               [ngClass]="{'public-trip-calculator__result--empty': !hasCalculation()}">
            <span class="public-trip-calculator__result-label">
                {{ hasCalculation() ? 'Итого для ' + formatNumber(effectiveDistance(), 0, 1) + ' км' : 'Расчёт поездки' }}
            </span>

            <ng-container *ngIf="hasCalculation(); else emptyResult">
                <strong>{{ formatMoney(estimatedCost()) }}</strong>
                <span class="public-trip-calculator__result-note">
                    {{ formatNumber(estimatedLitres(), 1, 2) }} л топлива по {{ formatMoney(fuelPrice, 2, 2) }}/л
                </span>

                <div class="public-trip-calculator__metrics">
                    <div>
                        <span>Только топливо на 1 км</span>
                        <strong>{{ formatMoney(costPerKm(), 2, 2) }}</strong>
                    </div>
                    <div>
                        <span>Стоимость 100 км</span>
                        <strong>{{ formatMoney(costPer100Km()) }}</strong>
                    </div>
                    <div>
                        <span>Расход на маршрут</span>
                        <strong>{{ formatNumber(estimatedLitres(), 1, 2) }} л</strong>
                    </div>
                </div>

                <p class="public-trip-calculator__fineprint">
                    Это быстрая оценка топливной части. В личном кабинете MotorDesk расчёт поездки может учитывать вашу
                    историю заправок, обслуживание и другие расходы автомобиля.
                </p>
            </ng-container>

            <ng-template #emptyResult>
                <strong>{{ distanceMode === 'route' ? 'Укажите города' : 'Введите дистанцию' }}</strong>
                <span class="public-trip-calculator__result-note">
                    <ng-container *ngIf="distanceMode === 'route'; else manualDistanceHint">
                        Выберите точки отправления и назначения — стоимость обновится после построения маршрута.
                    </ng-container>
                    <ng-template #manualDistanceHint>
                        Для расчёта нужны положительные значения километража, расхода и цены топлива.
                    </ng-template>
                </span>
            </ng-template>

            <div class="public-trip-calculator__actions">
                <a class="public-trip-calculator__button public-trip-calculator__button--primary"
                   [href]="registrationUrl()"
                   (click)="trackRegistrationClick()"
                   target="_blank"
                   rel="noopener">
                    Начать вести свои данные
                </a>
                <a class="public-trip-calculator__button public-trip-calculator__button--ghost"
                   [href]="demoUrl()"
                   (click)="trackDemoClick()"
                   target="_blank"
                   rel="noopener">
                    Сначала посмотреть демо
                </a>
            </div>
        </aside>
    </div>

    <div class="public-trip-calculator__meta" *ngIf="defaults || loadFailed">
        <span>Источник цены: {{ fuelPriceSourceLabel() }}.</span>
        <span *ngIf="defaults?.fuel_price_period?.date_from || defaults?.fuel_price_period?.date_to">
            Период: {{ sourcePeriodLabel() }}.
        </span>
        <span>Расход можно изменить вручную, если знаете значение для своего автомобиля.</span>
    </div>
</section>
